import { MessageCircle } from "lucide-react";
import { useChat } from "@/context/ChatContext";

export function ChatButton() {
  const { unread, drawerOpen, setDrawerOpen } = useChat();
  return (
    <button
      data-testid="chat-button"
      onClick={() => setDrawerOpen(!drawerOpen)}
      className="relative rounded-lg p-2 text-slate-500 transition-colors hover:bg-slate-100"
      title="Chats"
    >
      <MessageCircle className="h-5 w-5" />
      {unread.total > 0 && (
        <span data-testid="chat-unread-badge" className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-sky-500 px-1 text-[10px] font-bold text-white">
          {unread.total > 9 ? "9+" : unread.total}
        </span>
      )}
    </button>
  );
}
